module.exports = __webpack_public_path__ + "img/grid.0f7fc1ea.svg";